import viewDesign from "./ViewDesign";
export default viewDesign;
